import { render, staticRenderFns } from "./CourseCategorysListFilters.vue?vue&type=template&id=6cb18d76&"
import script from "./CourseCategorysListFilters.vue?vue&type=script&lang=js&"
export * from "./CourseCategorysListFilters.vue?vue&type=script&lang=js&"
import style0 from "./CourseCategorysListFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports